var map = {
	"./Drum_'n'_Bass__BPM164.wav": 7311,
	"./Drum_'n'_Bass__BPM184.wav": 9057,
	"./Electro_Pop__BPM128.wav": 436,
	"./Techno__BPM117.wav": 410,
	"./Techno__BPM123.wav": 6294,
	"./Tokyo_Night_Pop__BPM103.wav": 9832,
	"./Tokyo_Night_Pop__BPM107.wav": 7660,
	"./Tokyo_Night_Pop__BPM112.wav": 4834,
	"./Tokyo_Night_Pop__BPM113.wav": 3231,
	"./Tokyo_Night_Pop__BPM117.wav": 3077,
	"./Tokyo_Night_Pop__BPM120.wav": 9780,
	"./Tokyo_Night_Pop__BPM135.wav": 4485,
	"./Tokyonightpop__BPM110.wav": 3741
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8680;